/* eslint-disable max-lines-per-function */
/* eslint-disable max-lines */
import DropArea from "components/jiffy/drop-area/drop-area";
import { request } from "jiffy-api";
import Dropzone from "dropzone";
import {
  trackRudderstackImageUploadStarted,
  trackRudderstackImageRemoved
} from "common/utils/rudderstack/tracker";
import { sendDataLayer, track } from "jiffy-analytics";
import { submitDtfEvent, submitCompletedEvent } from "common/utils/mixpanel/submit-dtf-events";
import { generateUUID } from "common/utils/uuid";
import "./upload-files.scss";

export function attachUploadFiles($mainContainer, $dropArea = document.body) {
  if (!$mainContainer) return null;

  const dropAreaControl = new DropArea();
  const previewNode = $mainContainer.querySelector(".js-upload-files-row");
  const previewTemplate = previewNode.parentNode.innerHTML;
  const {
    acceptedFilesExtensions,
    disableRemovalUnlessSaved,
    maxFiles,
    maxSize,
    removalConfirmText
  } = $mainContainer.dataset;

  let mixpanelData = null;
  try {
    mixpanelData = JSON.parse($mainContainer.dataset.mixpanelData);
  } catch (e) {
    mixpanelData = null;
  }

  let { csrfToken } = $mainContainer.dataset;
  let startTime;

  if (!csrfToken) {
    try {
      const csrfTokenSelector = "meta[name='csrf-token']";
      const $csrfTokenTag = document.head.querySelector(csrfTokenSelector);
      csrfToken = $csrfTokenTag.content;
    } catch {
      csrfToken = null;
    }
  }

  previewNode.remove();
  const initParams = {
    url: $mainContainer.dataset.url,
    thumbnailWidth: $mainContainer.dataset.thumbnailWidth,
    thumbnailHeight: null,
    parallelUploads: 1,
    previewTemplate,
    autoQueue: true,
    autoProcessQueue: true,
    addRemoveLinks: false,
    previewsContainer: $mainContainer.querySelector(".js-upload-files-previews"),
    clickable: $mainContainer.querySelector(".js-upload-files-row-default .fileinput-button"),
    maxFilesize: maxSize || 5,
    maxThumbnailFilesize: maxSize || 5,
    dictRemoveFileConfirmation: removalConfirmText,
    acceptedFiles: acceptedFilesExtensions || ".jpg,.jpeg,.png,.heic",
    addedfile: () => {},
    drop: () => {},
    headers: csrfToken ? { "X-CSRF-TOKEN": csrfToken } : undefined,
    maxFiles: maxFiles || undefined
  };

  if ($dropArea.dropzone) {
    return Dropzone.forElement($dropArea);
  }

  const myDropzone = new Dropzone($dropArea, initParams);

  const $$modal = $("#js-upload-file-delete-modal");
  const $confirm = document.querySelector(".js-delete-file-confirm");

  $confirm.removedElement = null;

  const triggerFilesRemoval = async url => {
    await request(url, {}, "DELETE");
  };

  const manageAddFilesButton = () => {
    if (myDropzone.options.maxFiles === null) return;
    const canAddFiles = !(
      myDropzone.getAcceptedFiles().length >= myDropzone.options.maxFiles ||
      $(".dz-image-preview").length >= myDropzone.options.maxFiles
    );
    $(".js-upload-files-row-default").toggleClass("hide", !canAddFiles);
  };

  const removeFileHandler = el => {
    let payload = {};
    let removeUrl;
    if (el instanceof File) {
      myDropzone.removeFile(el);
      removeUrl = el.previewElement.dataset.removeUrl;
      payload = {
        ...JSON.parse(el.previewElement.dataset.removePayload),
        filename: el.name,
        resolution_width: el.width,
        resolution_height: el.height
      };
      trackRudderstackImageRemoved({
        file_name: el.name,
        file_type: el.type,
        file_size: el.size,
        location: "pdp",
        artworks_count: 1
      });
    } else {
      el.remove();
      removeUrl = el.dataset.removeUrl;
    }
    submitDtfEvent("image_removed", payload);
    if (removeUrl) {
      triggerFilesRemoval(removeUrl);
    }
    manageAddFilesButton();
  };

  $confirm.addEventListener("click", e => {
    const { removedElement } = e.currentTarget;
    removeFileHandler(removedElement);
    $$modal.modal("hide");
  });

  $mainContainer.querySelectorAll(".remove-prefilled-image").forEach($elem => {
    $elem.addEventListener("click", () => {
      if (removalConfirmText) {
        $confirm.removedElement = $elem.parentElement.parentElement;
        $$modal.modal("show");
      } else {
        removeFileHandler($elem.parentElement.parentElement);
      }
    });
  });

  const previewCount = $mainContainer.querySelectorAll(".dz-image-preview").length;
  const dropzoneMaxFiles = myDropzone.options.maxFiles;
  if (dropzoneMaxFiles !== null && previewCount >= dropzoneMaxFiles) {
    $mainContainer.querySelector(".js-upload-files-row-default").classList.add("hide");
  }

  myDropzone.on("addedfile", file => {
    if (mixpanelData) {
      track("transfer_choose_file_clicked", mixpanelData);
    }

    if (myDropzone.element === myDropzone.previewsContainer) {
      myDropzone.element.classList.add("dz-started");
    }

    if (myDropzone.previewsContainer && !myDropzone.options.disablePreviews) {
      file.previewElement = Dropzone.createElement(myDropzone.options.previewTemplate.trim());
      file.previewTemplate = file.previewElement; // Backwards compatibility

      if (file.type.match(/video.*/)) {
        const $video = document.createElement("video");
        $video.src = URL.createObjectURL(file);
        $video.currentTime = 1; // Get video at 1s
        $video.addEventListener("loadeddata", async () => {
          const canvas = document.createElement("canvas");
          canvas.width = $video.videoWidth;
          canvas.height = $video.videoHeight;
          const context = canvas.getContext("2d");
          context.drawImage($video, 0, 0, canvas.width, canvas.height);
          const thumbnailUrl = canvas.toDataURL("image/png");
          const thumbnailElement = file.previewElement.querySelector("[data-dz-thumbnail]");
          thumbnailElement.src = thumbnailUrl;
          file.previewElement.classList.add("dz-image-preview"); // Needed class from dropzone override

          await fetch(thumbnailUrl)
            .then(response => response.blob())
            .then(blob => {
              file.thumbnailBlob = blob;
              myDropzone.processFile(file);
            });
        });
        myDropzone.cancelUpload(file);
      }

      myDropzone.previewsContainer.appendChild(file.previewElement);
      file.previewElement.querySelectorAll("[data-dz-name]").forEach(node => {
        node.textContent = file.name;
      });
      file.previewElement.querySelectorAll("[data-dz-size]").forEach(node => {
        node.innerHTML = myDropzone.filesize(file.size);
      });

      if (myDropzone.options.addRemoveLinks) {
        // eslint-disable-next-line no-underscore-dangle
        file._removeLink = Dropzone.createElement(
          `<a class="dz-remove" href="javascript:;" data-dz-remove>${myDropzone.options.dictRemoveFile}</a>`
        );
        // eslint-disable-next-line no-underscore-dangle
        file.previewElement.appendChild(file._removeLink);
      }

      const removeFileEvent = e => {
        e.preventDefault();
        e.stopPropagation();
        if (file.status === Dropzone.UPLOADING) {
          return Dropzone.confirm(myDropzone.options.dictCancelUploadConfirmation, () =>
            myDropzone.removeFile(file)
          );
        }
        if (myDropzone.options.dictRemoveFileConfirmation) {
          $confirm.removedElement = file;
          return $$modal.modal("show");
        }
        return myDropzone.removeFile(file);
      };

      file.previewElement.querySelectorAll("[data-dz-remove]").forEach(removeLink => {
        removeLink.addEventListener("click", removeFileEvent);
      });
    }

    $($mainContainer.querySelector(".js-upload-files-row-default")).appendTo(
      $($mainContainer.querySelector(".js-upload-files-previews"))
    );
    dropAreaControl.hideDropArea();
    if (disableRemovalUnlessSaved) {
      file.previewElement.querySelector(".js-remove-preview").classList.add("hidden");
    }
    startTime = performance.now();
  });
  myDropzone.on("maxfilesreached", manageAddFilesButton);
  myDropzone.on("removedfile", manageAddFilesButton);
  myDropzone.on("error", function (file, errorMessage) {
    // Note: Tracking of image upload error events (`image_upload_error`, `file_type_not_allowed`)
    //       is done by logUploadErrorEvent(..) function in common/utils/mixpanel/dropzone-error-event-tracker.js
    this.removeFile(file);
    if (file.size > this.options.maxFilesize * 1024 * 1024) {
      alert(errorMessage);
    }
  });
  myDropzone.on("sending", (file, xhr, formData) => {
    file.uploadUuid = generateUUID();

    if (mixpanelData) {
      track("image_upload_started", {
        ...mixpanelData,
        upload_uuid: file.uploadUuid
      });
      trackRudderstackImageUploadStarted({
        dpi: 300,
        file_name: file.name,
        file_type: file.type,
        file_size: file.size,
        location: "pdp",
        business_line: "Transfers",
        artworks_count: 1,
        upload_uuid: file.uploadUuid
      });
    }

    // If the file is not a video, let Dropzone handle it as usual
    if (!file.type.match(/video.*/)) {
      return;
    }

    formData.append("thumbnail", file.thumbnailBlob);
  });
  myDropzone.on("maxfilesexceeded", function (file) {
    this.removeFile(file);
  });
  myDropzone.on("success", (file, response) => {
    if (mixpanelData) {
      track("image_upload_completed", {
        ...mixpanelData,
        artwork_id: response.id,
        upload_uuid: file.uploadUuid
      });
    }

    sendDataLayer({
      genericEvent: true,
      event: "ImageUploadCompleted",
      filetype: response.filetype,
      filesize: response.filesize
    });

    if (response.metadata) {
      const uploadedOn = response.metadata.uploaded_on || "pdp";
      const pdpType = uploadedOn === "pdp" ? "blanks" : "";

      const uploadCompletePayload = {
        artwork: response,
        uploadStartTime: startTime,
        dpi: 300,
        businessLine: "Transfers",
        artworksCount: 1,
        file,
        pdpType,
        uploadedOn,
        uploadUuid: file.uploadUuid
      };

      submitCompletedEvent(uploadCompletePayload);
    }

    let removePayload = {
      filetype: response.filetype,
      filesize: response.filesize
    };

    // Currently, metadata is present when upload is coming from the DTF dropzone.
    // Other places where we have a dropzone to upload a file are not passing the metadata attribute
    if (response.metadata) {
      removePayload = {
        ...removePayload,
        width: response.metadata.width,
        height: response.metadata.height,
        dpi: response.metadata.quality_upscale_dpi,
        page: response.metadata.uploaded_on || "pdp"
      };
    }

    $(".progress", file.previewElement).hide();

    const idElementClass = response.type === "videos" ? ".review-video-id" : ".review-photo-id";
    $(idElementClass, file.previewElement).val(response.id);

    // replace thumbnail with real image url, that will solve issue in IE 11/Edge
    const imgElement = file.previewElement.querySelector("img");
    imgElement.src = response.url;
    file.previewElement.dataset.removeUrl = response.remove_url;
    file.previewElement.dataset.removePayload = JSON.stringify(removePayload);
    manageAddFilesButton();

    if (disableRemovalUnlessSaved) {
      const removeControl = file.previewElement.querySelector(".js-remove-preview");
      removeControl.classList.remove("hidden");
    }

    imgElement.addEventListener("load", () => {
      const previewImage = $mainContainer.querySelector(".upload-files__preview-image");
      const previewWrapper = $mainContainer.querySelector(".upload-files__preview-wrapper");

      previewImage?.classList.add("upload-files__preview-image--fill-available");
      previewWrapper?.classList.remove("upload-files__preview-wrapper--force-width");
    });
  });

  return myDropzone;
}

export default () => {
  const $containers = document.querySelectorAll(".js-upload-files");

  return Array.from($containers).map(el => attachUploadFiles(el));
};
